<rdo-overlay [enabled]="loading"></rdo-overlay>
@if (data) {
  <div class="container-fluid">
    <div class="row pb-5 align-items-stretch">
      <div class="col-6 col-md-4">
        <div class="card rdo-card rdo-card-dashboard-default rdo-card-default-blue">
          <div class="card-header rdo-card-header">
            <div class="card-title">{{'main.tabs.equipment.rental_assets.asset_details.title' | translate}}</div>
          </div>
          <div class="card-body card-body-large container-fluid">
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.asset_details.client_make' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.Make | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.asset_details.client_model' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.Model | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.asset_details.model_year' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.ModelYear | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.core.tables.common.category' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.ClientCategory | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.asset_details.cat_class' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.ClientProductType | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.summary_information.description' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.ClientProductTypeDescription | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.equipment_id' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.EquipmentId | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.asset_details.equipment_type' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.EquipmentType | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.asset_details.serial_no' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.SerialNo | rdoString}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="card rdo-card rdo-card-dashboard-default rdo-card-default-blue">
          <div class="card-header rdo-card-header">
            <div class="card-title">{{'main.tabs.equipment.rental_assets.rouse_classification.title' | translate}}</div>
          </div>
          <div class="card-body card-body-large container-fluid">
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.rouse_classification.rouse_make' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.RouseMake}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.rouse_classification.rouse_model' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.RouseModel}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.core.tables.common.category' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.RouseCategory}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.core.common.counts.product_types.singular' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.RouseProductType}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="card rdo-card rdo-card-dashboard-default rdo-card-default-blue">
          <div class="card-header rdo-card-header">
            <div class="card-title">{{'main.tabs.equipment.rental_assets.branch_location.title' | translate}}</div>
          </div>
          <div class="card-body card-body-large container-fluid">
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.branch_location.region' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.Region | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.branch_location.district' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.District | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.branch_location.assigned_location' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.LocationCode | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.branch_location.branch' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.Branch | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.branch_location.address' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.BranchAddress | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.branch_location.city' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.BranchCity | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.branch_location.state' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.BranchState | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.branch_location.postal_code' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.BranchZipCode | rdoString}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row align-items-stretch">
      <div class="col-6 col-md-4">
        <div class="card rdo-card rdo-card-dashboard-default rdo-card-default-blue">
          <div class="card-header rdo-card-header">
            <div class="card-title">{{'main.tabs.equipment.rental_assets.current_rental_status.title' | translate}}</div>
          </div>
          <div class="card-body card-body-large container-fluid">
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.summary_information.on_rent' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.OnRent | rdoBoolean:translateService.currentLang}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.current_rental_status.status' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.RentalStatus | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.summary_information.days_in_status' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{getDaysInSameStatusQty()}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.current_rental_status.contract_no' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.ContractNo | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.core.common.counts.customers.singular' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.CustomerName | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.current_rental_status.customer_no' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.CustomerNumber | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.current_rental_status.is_rpo' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.IsRPO | rdoBoolean:translateService.currentLang}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.current_rental_status.is_rerent' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.IsReRent | rdoBoolean:translateService.currentLang}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="card rdo-card rdo-card-dashboard-default rdo-card-default-blue">
          <div class="card-header rdo-card-header">
            <div class="card-title">{{'main.tabs.equipment.rental_assets.revenue_and_maintenance.history' | translate}}</div>
          </div>
          <div class="card-body card-body-large container-fluid">
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.revenue_and_maintenance.ltd_total_revenue' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.LifeToDateRevenue | rdoCurrency:true:translateService.currentLang}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.revenue_and_maintenance.ltd_days_on_rent' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.LifeToDateDaysOnRent | rdoNumber:1}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.revenue_and_maintenance.ltd_rent_revenue' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.LifeToDateRentRevenue | rdoCurrency:true:translateService.currentLang}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.revenue_and_maintenance.ytd_rent_revenue' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.YearToDateRentRevenue | rdoCurrency:true:translateService.currentLang}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.revenue_and_maintenance.avg_rent_revenue' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.AverageRevenue | rdoCurrency:true:translateService.currentLang}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.revenue_and_maintenance.ltd_maintenance' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.LifeToDateMaintainance | rdoCurrency:true:translateService.currentLang}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.revenue_and_maintenance.ltd_labor' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.LifeToDateLabor | rdoCurrency:true:translateService.currentLang}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.revenue_and_maintenance.ltd_parts' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.LifeToDateParts | rdoCurrency:true:translateService.currentLang}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.revenue_and_maintenance.ytd_maintenance' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.YearToDateMaintainance | rdoCurrency:true:translateService.currentLang}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.revenue_and_maintenance.avg_maintenance' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.AverageMantainance | rdoCurrency:true:translateService.currentLang}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="card rdo-card rdo-card-dashboard-default rdo-card-default-blue">
          <div class="card-header rdo-card-header">
            <div class="card-title">{{'main.tabs.equipment.rental_assets.age_and_residual_value.title' | translate}}</div>
          </div>
          <div class="card-body card-body-large container-fluid">
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.age_and_residual_value.acquisition_date' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.AcquisitionDate | rdoLocalizedDate:'M/d/yyyy':locale | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.age_and_residual_value.date_put_in_rental' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.DatePutInRental | rdoLocalizedDate:'M/d/yyyy':locale | rdoString}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.age_and_residual_value.age_in_months' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.Age | rdoNumber:1}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.age_and_residual_value.meter' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.Meter | rdoCurrency:false:translateService.currentLang}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.age_and_residual_value.cost' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.Cost | rdoCurrency:true:translateService.currentLang}}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-5 control-label">{{'main.tabs.equipment.rental_assets.age_and_residual_value.nbv' | translate}}</div>
              <div class="col-7">
                <p class="control-description">{{data.NetBookValue | rdoCurrency:true:translateService.currentLang}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
